import React from "react";
import clsx from "clsx";
import {WARNING_COLOR} from "../../../themes/themeConfigurator";

const WarningIcon = props => {
  return <i className={clsx('fal fa-exclamation-circle', props.className)} style={{color: WARNING_COLOR}} />
};

export default WarningIcon;